"use client";
import { Api } from "@/Apis";
import { CenterOptionEnumBadge } from "@/Components";
import { CenterOptions } from "@/Helpers/CenterOptions";
import { ChildrenOf } from "@/Helpers/CenterOptions.types";
import { useApp, useT } from "@/Hooks";
import { SyncOutlined } from "@ant-design/icons";
import { Button, Space, Tooltip } from "antd";
import { FC, useState } from "react";

export interface CommonCommentChangeStatusForm {
  Id: number;
  StatusKey: ChildrenOf<"Status">;
}

export interface CommonCommentChangeStatusProps {
  model: CommonCommentChangeStatusForm;
  onChange?: () => void;
}

const CommonCommentChangeStatus: FC<CommonCommentChangeStatusProps> = ({
  model,
  onChange,
}) => {
  const [loading, setLoading] = useState(false);
  const { message } = useApp();
  const t = useT();
  const changeStatus = async () => {
    setLoading(true);
    try {
      const r = await Api.CommonComment.changeStatus({
        ...model,
        StatusKey:
          model.StatusKey == CenterOptions.Enum.Status.Active.key
            ? CenterOptions.Enum.Status.InActive.key
            : CenterOptions.Enum.Status.Active.key,
      });
      if (r.Success) {
        onChange?.();
        message.success(
          t("common.message.statusChanged", undefined, "Status changed."),
        );
      } else message.errors(r.Errors);
    } catch (error) { }
    setLoading(false);
  };
  return (
    <Space>
      <CenterOptionEnumBadge
        parentKey={CenterOptions.Enum.Status.key}
        value={model.StatusKey}
      />
      <Tooltip
        title={t("common.action.changeStatus", undefined, "Change status")}
      >
        <Button
          /*size="small"*/ shape="circle"
          icon={<SyncOutlined />}
          loading={loading}
          onClick={changeStatus}
        />
      </Tooltip>
    </Space>
  );
};

export default CommonCommentChangeStatus;
